import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Catalog } from "~/pages/Administrative/Message/Catalog";

const sections = [
  { kind: "templates", alias: "financial-collections-templates", path: "/Financial/Collections/Templates" },
  { kind: "campaigns", alias: "financial-collections-campaigns", path: "/Financial/Collections/Campaigns" },
  { kind: "history", alias: "financial-collections-history", path: "/Financial/Collections/History" },
];

const sectionAccess = (accesses, alias) => accesses?.hierarchy
  ?.find((item) => item.alias === "financial")?.children
  ?.find((item) => item.alias === "financial-collections")?.children
  ?.find((item) => item.alias === alias)?.MenuHierarchyXGroup;

export default function FinancialCollections() {
  return <Outlet />;
}

export function CollectionsIndex() {
  const accesses = useSelector((state) => state.auth.accesses);
  const first = sections.find((section) => sectionAccess(accesses, section.alias)?.view);
  return first ? <Navigate to={first.path} replace /> : <p role="alert" className="h-full flex-1 bg-white p-4 text-sm">You do not have permission to view any Collections section.</p>;
}

export function CollectionsSection({ kind }) {
  const { filial, accesses } = useSelector((state) => state.auth);
  const access = sectionAccess(accesses, sections.find((section) => section.kind === kind).alias) || {};
  return <Catalog key={String(filial?.id) + ":collections:" + kind + ":" + JSON.stringify(access)} kind={kind} category="financial" filial={filial} access={access} />;
}
